// extracted by mini-css-extract-plugin
export default {"button":"CustomColumnMenu_button__Q87Ao","popup-content":"CustomColumnMenu_popup-content__ig8DX"};